/* eslint-disable jsdoc/require-jsdoc */
import React, { useState } from 'react';
import SVGComponent from '../../SVG/SVGComponent';
import { SVG_ICONS } from '../../../constants';

function getOptionsLabelFromIds(ids, options) {
  const idMapping = ids.reduce((acc, id) => {
    acc[id] = id;
    return acc;
  }, {});

  return options.filter((option) => idMapping[option.id]);
}

function MultiSelect({
  label, options, value, onChange,
}) {
  const [selectIsOpen, setSelectIsOpen] = useState(false);
  const selectedValues = getOptionsLabelFromIds(value, options);

  function toggleSelectDropdownOpen() {
    setSelectIsOpen((prev) => !prev);
  }

  function removeSelection(itemId) {
    const newSelections = [...value].filter((id) => id !== itemId);
    onChange(newSelections);
  }

  function resetDropdown() {
    onChange([]);
  }

  function toggleItemSelection(item) {
    const itemIsSelected = [...value].some((id) => id === item.id);
    const newSelectedItems = itemIsSelected
      ? [...value].filter((id) => id !== item.id)
      : [...value].concat(item.id);

    onChange(newSelectedItems);
  }

  return (
    <div className="filter__field">
      <label className="filter__field-label">{label}</label>
      <div
        className={`filter__field-input d-flex align-items-center hasDropdown ${selectIsOpen ? 'open' : ''}`}
        onClick={toggleSelectDropdownOpen}
      >
        {value.length === 0 && <span className="m-l-5">All</span> }
        <span className="filter__field-input-caret" />
        {selectedValues.map((item) => (
          <div className="filter__field-input-item" key={item.id}>
            <span>{item.label}</span>
            <SVGComponent
              src={`${SVG_ICONS.utility}#close-sm`}
              className="close-btn m-l-5"
              onClick={removeSelection.bind(null, item.id)}
            />
          </div>
        ))}
        <div className="filter__field-input-list">
          <div
            className={`filter__field-input-list-item
             ${value.length === 0 && 'active'}`}
            onClick={resetDropdown}
          >
            All
          </div>
          {options.map((option) => (
            <div
              className={`filter__field-input-list-item
             ${value.some((id) => id === option.id) && 'active'}`}
              key={option.label}
              onClick={toggleItemSelection.bind(null, option)}
            >
              {option.label}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default MultiSelect;
